export const filterUTMParams = queryString => {
  if (!queryString) return '';
  const paramsArray = queryString.split('&');
  const filteredParams = paramsArray.filter(param => param.startsWith('utm_') || param.startsWith('gclid'));
  if (filteredParams.length === 0) return '';

  return filteredParams.join('&');
};
